export async function exec(code: string, globals: {[globalVar: string]: any}) {
  const app = `(async () => {${code}})()`
  const fnKeys = [...Object.keys(globals), app]
  //@ts-ignore
  const fnValues = Object.values(globals)

  let hasError = false
  let error
  try {
    await Function(...fnKeys)(...fnValues)
  } catch (err) {
    hasError = true
    error = err
  }
  return hasError ? error : null
}
